import React from 'react'

interface IUseOutsideClickHook {
  ref: React.RefObject<HTMLElement>
  onOutsideClick: () => void
}

export default function useOutsideClick({
  ref,
  onOutsideClick,
}: IUseOutsideClickHook) {
  React.useEffect(() => {
    function handleClickOutside(clickEvent: MouseEvent) {
      // check whether click was outside the target and content elements
      if (ref.current && !ref.current.contains(clickEvent.target as Node)) {
        onOutsideClick()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, onOutsideClick])
}
